import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { Spin, Icon } from 'antd'
import HomeDashboard from 'modules/home-dashboard/index/components/HomeDashboard'
import {
  PureBackgroundStyledContent,
  StyledLogo,
  StyledLogoiSupply,
  StyledDiv,
  StyledRow,
  StyledCol,
} from '../../../styled/common-styled'
import { checkOauthLogin, removeCredentials } from '../actions'
import Form from './Form'
import FormLoginByToken from './FormLoginByToken'
import FormLogin from '../../auth/components/Form'
import { checkLogin } from '../../auth/actions'

// พื้นหลัง: ของเดิม height 100% อ้างอิง parent ที่ไม่ได้ตั้งความสูงไว้
// บนมือถือเลยสูงไม่ถึงจอ ภาพพื้นหลังขาดครึ่ง
const LoginBg = styled(StyledDiv)`
  min-height: 100vh;
  min-height: 100dvh;
`

// จอเล็กไม่ต้องดันการ์ดลงมามาก ไม่งั้นปุ่ม login หลุดขอบล่าง
const LoginCol = styled(StyledCol)`
  @media (max-width: 767px) {
    padding-top: 32px;
  }
`

// การ์ดขาว — จอเล็กลดขอบในลง ไม่งั้นช่องกรอกเหลือความกว้างนิดเดียว
// ฟอร์มกับ Spin ข้างในตั้ง margin 20px แบบ inline ไว้ ต้อง !important ถึงจะทับได้
const LoginCard = styled.div`
  background-color: #fff;
  padding: 10% 40px;
  border-radius: 25px;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;

  @media (max-width: 767px) {
    padding: 24px 16px;
    border-radius: 16px;

    .ant-spin-nested-loading,
    form {
      margin: 0 !important;
    }

    img {
      width: 62%;
    }
  }
`

class OauthLogin extends Component {
  state = {
    bluenetLoading: false,
  }

  componentDidMount() {
    const search = window.location.search
    const params = new URLSearchParams(search)
    const userType = params.get('userType')
    const userName = params.get('userName')
    const jwt = params.get('jwt')
    const truckNo = params.get('truckNo')
    const code = params.get('code')

    if (typeof userType != 'undefined' && typeof userName != 'undefined') {
      if (userType && userName && userType !== '' && userName !== '') {
        this.setState({ bluenetLoading: true })
        this.props.removeCredentials()
        this.props.checkLogin({
          username: userName,
          password: 'password',
          loginType: 'bluenet-via-url',
          userType: userType,
          jwt: jwt,
          truckNo: truckNo,
          code,
          cb: () => window.location.replace('/tracking/?truckNo=' + truckNo),
        })
      }
    }
  }

  checkLogin = values => {
    this.props.checkOauthLogin({ ...values, cb: this.handleCallbackUrl })
  }

  handleCallbackUrl = () => {
    const params = new URLSearchParams(window.location.search)
    const redirectParam = params.get('redirect')
    if (redirectParam) {
      window.location.replace(redirectParam)
      return
    }
    const callbackUrl = localStorage.getItem('callbackUrl')
    if (!!callbackUrl) window.location.replace(callbackUrl)
    else window.location.replace('/')
  }

  checkLoginForm = values => {
    let self = this
    self.props.checkLogin({ ...values, cb: this.handleCallbackUrl })
  }

  onClickBack = () => {
    window.history.back()
  }
  render() {
    const url = new URL(window.location.href)
    const redirectParam = url.searchParams.get('redirect')

    if (this.props.auth.done) {
      if (redirectParam) {
        window.location.replace(redirectParam)
        return null
      }
      return (
        <PureBackgroundStyledContent>
          <HomeDashboard />
        </PureBackgroundStyledContent>
      )
    }

    return (
      <LoginBg img={'/img/bgg.png'}>
        <StyledRow>
          <LoginCol
            xs={{ span: 22, offset: 1 }}
            sm={{ span: 18, offset: 3 }}
            md={{ span: 9, offset: 8 }}
            lg={{ span: 7, offset: 8 }}
            xl={{ span: 7, offset: 8 }}
          >
            <LoginCard>
              {url.pathname === '/logincpac' ? (
                <Icon
                  type="arrow-left"
                  onClick={this.onClickBack}
                  style={{ color: '#1890FF' }}
                />
              ) : (
                <></>
              )}
              {process.env.REACT_APP_WEB_ENDPOINT === 'isupply' ? (
                <StyledLogoiSupply span={24} src="/img/isupply.png" alt="" />
              ) : (
                <StyledLogo span={24} src="/img/2.png" alt="" />
              )}
              <Spin
                spinning={
                  this.props.oauth.loading ||
                  this.props.auth.loading ||
                  this.state.bluenetLoading
                }
                size="large"
                style={{ height: '100%', margin: '0px 20px' }}
              >
                {url.pathname === '/logincpac' ? (
                  <FormLogin
                    auth={this.props.auth}
                    onSubmit={this.checkLoginForm}
                  />
                ) : url.pathname === '/login-by-token' ? (
                  <FormLoginByToken
                    auth={this.props.auth}
                    onSubmit={this.checkLoginForm}
                  />
                ) : (
                  <Form auth={this.props.auth} onSubmit={this.checkLogin} />
                )}
              </Spin>
            </LoginCard>
          </LoginCol>
        </StyledRow>
      </LoginBg>
    )
  }
}

export default connect(
  ({ token, profile, auth, oauth }) => ({ token, profile, auth, oauth }),
  {
    checkLogin: checkLogin.request,
    checkOauthLogin: checkOauthLogin.request,
    removeCredentials,
  },
)(OauthLogin)
